import React, { useRef, useState } from 'react';

const OTPInput = ({ value = '', onChange, length = 5, className = '' }) => {
  const [otp, setOtp] = useState(value.split('').slice(0, length));
  const inputs = useRef([]);

  const handleChange = (element, index) => {
    const val = element.value.replace(/[^0-9]/g, '');
    
    if (val.length > 1) {
      const pastedValue = val.slice(0, length - index).split('');
      const newOtp = [...otp];
      pastedValue.forEach((v, i) => {
        newOtp[index + i] = v;
      });
      setOtp(newOtp);
      onChange(newOtp.join(''));
      
      const nextIndex = Math.min(index + pastedValue.length, length - 1);
      inputs.current[nextIndex]?.focus();
    } else {
      const newOtp = [...otp];
      newOtp[index] = val;
      setOtp(newOtp);
      onChange(newOtp.join(''));
      
      if (val && index < length - 1) {
        inputs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/[^0-9]/g, '').slice(0, length);
    const newOtp = pastedData.split('');
    setOtp(newOtp);
    onChange(newOtp.join(''));
    
    if (newOtp.length > 0) {
      inputs.current[Math.min(newOtp.length - 1, length - 1)]?.focus();
    }
  };

  return (
    <div className={`flex gap-3 justify-center ${className}`}>
      {Array.from({ length }, (_, i) => (
        <input
          key={i}
          ref={(el) => inputs.current[i] = el}
          type="text"
          inputMode="numeric"
          maxLength="1"
          value={otp[i] || ''}
          onChange={(e) => handleChange(e.target, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          onPaste={handlePaste}
          className="w-12 h-14 text-center text-xl font-bold bg-[#F9F9F9] border-2 border-[#E6E6E6] rounded-xl outline-none focus:border-pink-300 transition-colors text-[#0C1D40]"
        />
      ))}
    </div>
  );
};

export default OTPInput;